import fastdom from "fastdom";

const _observers = new WeakMap();
const _animated = new WeakSet();

export const showFade = {
    bind: (el) => {
        const addToTl = () => {
            fastdom.mutate(() => {
                el.style.opacity = '';
                el.style.transform = '';
            });
        };

        el.style.opacity = '0';
        el.style.transform = 'translateY(100px)';

        new Promise((res) => {
            fastdom.mutate(() => {
                el.style.opacity = '0';
                el.style.transform = 'translateY(100px)';
                el.dataset.showFade = 'true';
                res();
            });
        }).then(() => new Promise((res) => {
            fastdom.mutate(() => {
                el.style.transition = 'opacity .6s, transform .6s';
                res();
            });
        })).then(() => {
            if (!('IntersectionObserver' in window)) {
                _animated.add(el);
                addToTl();
                return;
            }
    
            const observer = new IntersectionObserver(
                ([entry]) => {
                    if (entry.isIntersecting && !_animated.has(el)) {
                        _animated.add(el);
                        addToTl();
                    }
                },
                {
                    root: null,
                    rootMargin: '0px',
                    threshold: 0,
                }
            );
    
            _observers.set(el, observer);
          
            if (el) {
                observer.observe(el);
            }
        });
    },
    unbind: (el) => {
        const observer = _observers.get(el);
        if (observer) {
            observer.unobserve(el);
        }
    },
};
